import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play, Volume2, VolumeX } from "lucide-react";
import { LogoMark } from "./Logo";
import { useBrand } from "../../context/brand";

const PREVIEW_SECONDS = 3;

export const ShortsVideo = () => {
  const ref = useRef(null);
  const brand = useBrand();
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [progress, setProgress] = useState(0);

  const startFull = () => {
    const v = ref.current;
    if (!v) return;
    v.currentTime = 0;
    v.muted = false;
    setMuted(false);
    v.play().catch(() => {});
    setPlaying(true);
  };

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    if (!playing) return startFull();
    if (v.paused) v.play().catch(() => {}); else v.pause();
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    if (ref.current) ref.current.muted = !muted;
    setMuted(!muted);
  };

  const onTime = (e) => {
    const v = e.currentTarget;
    if (!playing) {
      if (v.currentTime >= PREVIEW_SECONDS) v.currentTime = 0;
      return;
    }
    setProgress(v.currentTime / (v.duration || 1));
  };

  const onEnded = (e) => {
    const v = e.currentTarget;
    setPlaying(false);
    setProgress(0);
    v.muted = true;
    v.currentTime = 0;
    v.play().catch(() => {});
  };

  return (
    <div className="lz-shorts" onClick={toggle} data-testid="welcome-video">
      <video ref={ref} poster={brand.video.poster} playsInline muted autoPlay preload="auto"
        className="absolute inset-0 w-full h-full object-cover" onTimeUpdate={onTime} onEnded={onEnded}>
        <source src={brand.video.webm} type="video/webm" />
        <source src={brand.video.mp4} type="video/mp4" />
      </video>
      <div className="lz-shorts-shade" />
      <div className="lz-shorts-top">
        <span className="lz-chip">{playing ? "Boas-vindas" : "Toque para ouvir"}</span>
        {playing && (
          <button data-testid="welcome-video-mute" onClick={toggleMute} className="lz-icon-btn" aria-label="Som">
            {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
          </button>
        )}
      </div>
      {!playing && (
        <motion.button data-testid="welcome-video-play" className="lz-play" aria-label="Reproduzir com som"
          initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} whileTap={{ scale: 0.9 }}>
          <Play size={28} fill="currentColor" />
        </motion.button>
      )}
      <div className="lz-shorts-bottom">
        <div className="flex items-center gap-2">
          <LogoMark size={30} />
          <span className="text-[13px] font-semibold">{brand.handle}</span>
        </div>
        <p className="text-[13px] leading-snug mt-1.5 text-white/90">Tudo sobre o app em menos de 1 minuto.</p>
        <div className="lz-progress"><div style={{ transform: `scaleX(${progress})` }} /></div>
      </div>
    </div>
  );
};
